<template>
  <div>
    <CsimSchemaAttributeUnSelectFormList ref="CsimSchemaAttributeUnSelectFormList" @formListRefresh="formListRefresh" @getModelData="getModelData" :model="model" :existIdList="existIdList"></CsimSchemaAttributeUnSelectFormList>
    <hr/>
    <CsimSchemaAttributeSelectedFormList ref="CsimSchemaAttributeSelectedFormList" @changeFormDesignTab="changeFormDesignTab" :model="model"></CsimSchemaAttributeSelectedFormList>
  </div>
</template>
<script>

import CsimSchemaAttributeUnSelectFormList from "./CsimSchemaAttributeUnSelectFormList";
import CsimSchemaAttributeSelectedFormList from "./CsimSchemaAttributeSelectedFormList";

export default {
  name: "CsimSchemaPeriod",
  components: {
    CsimSchemaAttributeUnSelectFormList,
    CsimSchemaAttributeSelectedFormList,
  },
  props: {
    model: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
    }
  },
  created () {
  },
  computed: {
    existIdList(){
      if (this.formList) {
        return this.formList.map(item=>item.formId)
      } else {
        return [];
      }
    }
  },
  methods: {
    handleSetSchema(record) {
      this.$refs.CsimSchemaAttributeUnSelectFormList.handleSetSchema(record);
      this.$refs.CsimSchemaAttributeSelectedFormList.handleSetSchema(record);
    },
    formListRefresh(){
      this.$refs.CsimSchemaAttributeSelectedFormList.loadForm();
    },
    getModelData() {
      return this.$emit('getModelData'); 
    },
    changeFormDesignTab(type, formInfo) {
      this.$emit("changeFormDesignTab", type, formInfo);
    }
  }
};
</script>
